import { n as l } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import a from "../Components/NcInputField.mjs";
import o from "debounce";
import c from "@nextcloud/axios";
import { loadState as d } from "@nextcloud/initial-state";
import { generateOcsUrl as u } from "@nextcloud/router";
import { r as p, q as f, a as n } from "./_l10n-BZu8wI2q.mjs";
import { l as m } from "./logger-C7qcfVW8.mjs";
const h = {
  name: "EyeIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var _ = function() {
  var t = this, s = t._self._c;
  return s("span", t._b({ staticClass: "material-design-icon eye-icon", attrs: { "aria-hidden": t.title ? null : !0, "aria-label": t.title, role: "img" }, on: { click: function(i) {
    return t.$emit("click", i);
  } } }, "span", t.$attrs, !1), [s("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [s("path", { attrs: { d: "M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" } }, [t.title ? s("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, g = [], v = /* @__PURE__ */ l(
  h,
  _,
  g,
  !1,
  null,
  null,
  null,
  null
);
const w = v.exports, C = {
  name: "EyeOffIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var y = function() {
  var t = this, s = t._self._c;
  return s("span", t._b({ staticClass: "material-design-icon eye-off-icon", attrs: { "aria-hidden": t.title ? null : !0, "aria-label": t.title, role: "img" }, on: { click: function(i) {
    return t.$emit("click", i);
  } } }, "span", t.$attrs, !1), [s("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [s("path", { attrs: { d: "M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z" } }, [t.title ? s("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, b = [], $ = /* @__PURE__ */ l(
  C,
  y,
  b,
  !1,
  null,
  null,
  null,
  null
);
const P = $.exports;
p(f);
const r = d("core", "capabilities", {}).password_policy || null, A = new Set(Object.keys(a.props)), x = {
  name: "NcPasswordField",
  components: {
    NcInputField: a,
    Eye: w,
    EyeOff: P
  },
  // Allow forwarding all attributes
  inheritAttrs: !1,
  props: {
    /**
     * Any [NcInputField](#/Components/NcFields?id=ncinputfield) props
     */
    // Not an actual prop but needed to show in vue-styleguidist docs
    // eslint-disable-next-line
    " ": {},
    // Reuse all the props from NcInputField for better typing and documentation
    ...a.props,
    // Redefined props
    /**
     * Controls whether to display the trailing button.
     */
    showTrailingButton: {
      type: Boolean,
      default: !0
    },
    // Removed NcInputField props, defined only by this component
    trailingButtonLabel: void 0,
    // Custom props
    /**
     * Check if the user entered a valid password using the password_policy
     * app if available.
     *
     * Warning: this doesn't replace server side checking and will do nothing
     * if the password_policy app is disabled.
     */
    checkPasswordStrength: {
      type: Boolean,
      default: !1
    },
    /**
     * The minlength property defines the minimum number of characters
     * (as UTF-16 code units) the user can enter
     */
    minlength: {
      type: Number,
      default: 0
    },
    /**
     * The maxlength property defines the maximum number of characters
     * (as UTF-16 code units) the user can enter
     */
    maxlength: {
      type: Number,
      default: null
    }
  },
  emits: [
    "valid",
    "invalid",
    "update:value"
  ],
  data() {
    return {
      isPasswordHidden: !0,
      internalHelpMessage: "",
      isValid: null
    };
  },
  computed: {
    computedError() {
      return this.error || this.isValid === !1;
    },
    computedSuccess() {
      return this.success || this.isValid === !0;
    },
    computedHelperText() {
      return this.helperText.length > 0 ? this.helperText : this.internalHelpMessage;
    },
    rules() {
      const { minlength: e } = this;
      return {
        minlength: e != null ? e : r == null ? void 0 : r.minLength
      };
    },
    trailingButtonLabelPassword() {
      return this.isPasswordHidden ? n("Show password") : n("Hide password");
    },
    propsAndAttrsToForward() {
      return {
        // Proxy all the HTML attributes
        ...this.$attrs,
        // Proxy original NcInputField's props
        ...Object.fromEntries(
          Object.entries(this.$props).filter(([e]) => A.has(e))
        )
      };
    }
  },
  watch: {
    value(e) {
      if (this.checkPasswordStrength) {
        if (r === null)
          return;
        this.checkPassword(e);
      }
    }
  },
  methods: {
    /**
     * Focus the input element
     *
     * @public
     */
    focus() {
      this.$refs.inputField.focus();
    },
    /**
     * Select all the text in the input
     *
     * @public
     */
    select() {
      this.$refs.inputField.select();
    },
    handleInput(e) {
      this.$emit("update:value", e.target.value);
    },
    togglePasswordVisibility() {
      this.isPasswordHidden = !this.isPasswordHidden;
    },
    checkPassword: o(async function(e) {
      try {
        const { data: t } = await c.post(u("apps/password_policy/api/v1/validate"), { password: e });
        if (this.isValid = t.ocs.data.passed, t.ocs.data.passed) {
          this.internalHelpMessage = n("Password is secure"), this.$emit("valid");
          return;
        }
        this.internalHelpMessage = t.ocs.data.reason, this.$emit("invalid");
      } catch (t) {
        m.error("Password policy returned an error", t);
      }
    }, 500)
  }
};
var L = function() {
  var t = this, s = t._self._c;
  return s("NcInputField", t._g(t._b({ ref: "inputField", attrs: { type: t.isPasswordHidden ? "password" : "text", "trailing-button-label": t.trailingButtonLabelPassword, "helper-text": t.computedHelperText, error: t.computedError, success: t.computedSuccess, minlength: t.rules.minlength }, on: { "trailing-button-click": t.togglePasswordVisibility, input: t.handleInput }, scopedSlots: t._u([{ key: "trailing-button-icon", fn: function() {
    return [t.isPasswordHidden ? s("Eye", { attrs: { size: 18 } }) : s("EyeOff", { attrs: { size: 18 } })];
  }, proxy: !0 }]) }, "NcInputField", t.propsAndAttrsToForward, !1), t.$listeners), [t._t("default")], 2);
}, F = [], k = /* @__PURE__ */ l(
  x,
  L,
  F,
  !1,
  null,
  null,
  null,
  null
);
const O = k.exports;
export {
  O as N
};
